import { Controller } from "@hotwired/stimulus";

// Superhuman-style j/k navigation between task review pages: j opens the next
// card in the current column, k the previous one. The URLs are computed
// server-side (same ordering and filters as the board) and passed in as
// values; either may be absent at the column edges.
//
//   <div data-controller="task-review"
//        data-action="keydown@window->task-review#key"
//        data-task-review-next-url-value="..."
//        data-task-review-prev-url-value="...">
export default class extends Controller {
  static values = {
    nextUrl: { type: String, default: "" },
    prevUrl: { type: String, default: "" },
  };

  key(event) {
    if (event.defaultPrevented) return;
    if (event.metaKey || event.ctrlKey || event.altKey) return;
    // The page has edit-draft and rewrite-guidance textareas; never steal
    // keystrokes from a typing context.
    if (event.target instanceof Element && event.target.closest("input, textarea, select, [contenteditable]")) return;

    const key = event.key.toLowerCase();
    if (key === "j" && this.nextUrlValue) {
      event.preventDefault();
      window.Turbo.visit(this.nextUrlValue);
    } else if (key === "k" && this.prevUrlValue) {
      event.preventDefault();
      window.Turbo.visit(this.prevUrlValue);
    }
  }
}
